import { render, staticRenderFns } from "./EmailRegistration.vue?vue&type=template&id=198aa36a&"
import script from "./EmailRegistration.vue?vue&type=script&lang=js&"
export * from "./EmailRegistration.vue?vue&type=script&lang=js&"
import style0 from "./EmailRegistration.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "EmailRegistration.vue"
export default component.exports